<template>
  <div class="content">
    <!--  -->
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>施工管理</el-breadcrumb-item>
            <el-breadcrumb-item>物料管理</el-breadcrumb-item>
            <el-breadcrumb-item>入库登记</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 3vh);width:100%;position: relative;">
      <!-- 侧边树 -->
      <el-aside width="16%" style="height:100%" class="aside">
        <!-- <div style="height:13%">
          <el-input
            v-model="search.entName"
            placeholder="请输入班组名称"
            style="margin-bottom: 10px;width:85%;margin-top: 20px;font-size:12px"
            clearable
          >
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>-->
        <el-card style="height:100%;overflow-y: auto;">
          <el-tree
            :data="dataTree"
            ref="tree"
            :props="defaultProps"
            default-expand-all
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
            node-key="itemsType"
            :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys"
          ></el-tree>
        </el-card>
      </el-aside>
      <!-- 右边 -->
      <el-main
        class="build-CURD"
        style="height: 100%;padding:0px !important; padding-left: 20px !important; position: relative;width: 84%;"
      >
        <el-card class="box-card box-card_right" style="height:100%;padding:0px !important">
          <!-- 搜索框上 -->
          <!-- <el-row :gutter="20" type="flex" justify="space-between"> -->
          <!-- <el-col :span="6"> -->
          <div
            style=" margin: 10px 20px;display:flex;justify-content: space-between;align-items: center;height:60px;"
          >
            <div class="grid-search">
              <el-input v-model="search.name" placeholder="请输入材料名称" clearable @input="watchInput">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
              <el-date-picker
                v-model="search.date"
                @change="doFilter"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              ></el-date-picker>
            </div>

            <div style="display:flex;align-items: center;width:20%;justify-content: space-between">
              <el-button
                type="success"
                @click="add"
                style="margin-left:50px;background-color: #67C23A;border-color: #67C23A;"
              >添加入库</el-button>
              <el-button
                type="success"
                @click="exportma(1)"
                style="margin-left:50px;background-color: #67C23A;border-color: #67C23A;"
              >导出模板</el-button>
              <!-- </div> -->
            </div>
            <div style="display:flex;align-items: center;width:10%;justify-content: space-between">
              <el-tooltip class="item" effect="dark" content="导出表" placement="top-end">
                <img
                  @click="exportma(2)"
                  class="icon_hover"
                  src="../../../assets/image/export.png"
                  alt
                  srcset
                />
              </el-tooltip>
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :headers="uploadHead"
                :data="uploadData"
                :show-file-list="false"
                :on-success="handleAppSuccess"
              >
                <!-- <el-button type="primary" icon="el-icon-upload">导入工资表</el-button> -->
                <el-tooltip class="item" effect="dark" content="导入表" placement="top-end">
                  <img class="icon_hover" src="../../../assets/image/import.png" alt srcset />
                </el-tooltip>
              </el-upload>
            </div>
          </div>
          <!-- <div
            style="margin: 0px 20px 20px;display:flex;justify-content: space-between;justify-content: space-between;height:40px"
          >
            <el-date-picker
              v-model="search.month"
              @change="doFilter"
              type="month"
              value-format="yyyy-MM"
              placeholder="选择月"
            ></el-date-picker>
            <div style="display:flex;margin:0px 0px 0px 0px;">
              <el-button
                type="success"
                @click="exportAgree"
                style="margin-left:50px;background-color: #67C23A;border-color: #67C23A;"
              >导出表</el-button>
              <el-upload
                class="upload-demo"
                :action="uploadPersonUrl"
                :headers="uploadHead"
                :data="uploadPersonData"
                :show-file-list="false"
                style="margin-left:50px;"
                :on-success="personSuccess"
              >
                <el-button type="primary" icon="el-icon-upload">导入表</el-button>
              </el-upload>
            </div>
          </div>-->
          <div class="build-table">
            <el-table
              :data="listData"
              height="100%"
              border
              style="width: 100%;"
              stripe
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <!-- <el-table-column type="selection" width="55"></el-table-column> -->
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <a>{{ scope.$index+1}}</a>
                </template>
              </el-table-column>
              <el-table-column :label="nameCode">
                <template slot-scope="scope">
                  <a>{{scope.row.materialCoding }}</a>
                </template>
              </el-table-column>
              <el-table-column label="供应商">
                <template slot-scope="scope">
                  <a>{{ scope.row.supplier}}</a>
                </template>
              </el-table-column>
              <el-table-column :label="nameMat">
                <template slot-scope="scope">
                  <span>{{ scope.row.materialName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="规格型号" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.specifications }}</span>
                </template>
              </el-table-column>
              <el-table-column label="计量单位" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.measuringUnit }}</span>
                </template>
              </el-table-column>
              <el-table-column label="数量">
                <template slot-scope="scope">
                  <span>{{ scope.row.number }}</span>
                </template>
              </el-table-column>
              <el-table-column label="单价">
                <template slot-scope="scope">
                  <span>{{ scope.row.unitPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column label="合计" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.summation }}</span>
                </template>
              </el-table-column>
               <el-table-column label="生产日期" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.productionDate  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="材料图片">
                <template slot-scope="scope">
                  <el-image
                    v-if="scope.row.materialPhoto!=''"
                    style="width: 5vh; height: 5vh;cursor: pointer;"
                    :src="http+scope.row.materialPhoto"
                    :preview-src-list="scope.row.srcList"
                  ></el-image>
                  <img
                    v-else
                    src="../../../assets/image/zanwutupian.png"
                    style="width: 5vh; height: 5vh;cursor: pointer;"
                  />
                </template>
              </el-table-column>
               <el-table-column label="发票图片">
                <template slot-scope="scope">
                  <el-image
                    v-if="scope.row.invoicePhoto!=''"
                    style="width: 5vh; height: 5vh;cursor: pointer;"
                    :src="http+scope.row.invoicePhoto"
                    :preview-src-list="scope.row.srcList1"
                  ></el-image>
                  <img
                    v-else
                    src="../../../assets/image/zanwutupian.png"
                    style="width: 5vh; height: 5vh;cursor: pointer;"
                  />
                </template>
              </el-table-column>
              <el-table-column label="登记人" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.personName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="登记时间"
                width="160"
                prop="salaryMonth"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate}}</span>
                </template>
              </el-table-column>

              <el-table-column label="操作" width="200">
                <template slot-scope="scope" >
                  <el-button size="mini" @click="erCode(scope.$index, scope.row)">二维码</el-button>
                  <el-button size="mini" @click="edit(scope.$index, scope.row)">修改发票</el-button>
                  <el-tooltip class="item" effect="dark" :content="scope.row.note" placement="left">
                    <el-button size="mini" type="warning" @click="addMarks(scope.row)" style="margin-top:1vh;">备注</el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <!--添加材料弹出框  -->
            <el-dialog
              :title="diaTitle"
              :visible.sync="editFormVisible"
              center
              :append-to-body="true"
              :lock-scroll="false"
              width="30%"
            >
              <el-form
                :model="editForm"
                ref="editForm"
                label-width="35%"
                label-position="left"
                class="teamPage"
                :rules="teamRules"
              >
                <el-form-item :label="nameCode" prop="materialCoding" key="1">
                  <el-input v-model="editForm.materialCoding" autocomplete="off" @change="getMate">
                    <el-button slot="append" type="mini" @click="auto">生成编号</el-button>
                  </el-input>
                </el-form-item>
                <el-form-item label="供应商" prop="supplier">
                  <el-input v-model="editForm.supplier" autocomplete="off" @change="getMate"></el-input>
                </el-form-item>
                <el-form-item   :label="nameMat" prop="materialName">
                  <el-input v-model="editForm.materialName" autocomplete="off" @change="getMate"></el-input>
                </el-form-item>
                <el-form-item label="规格型号" prop="specifications">
                  <el-input v-model="editForm.specifications" autocomplete="off" @change="getMate"></el-input>
                </el-form-item>
                <el-form-item label="计量单位" prop="userType">
                  <el-select v-model="editForm.measuringUnit" placeholder="请选择">
                    <el-option
                      v-for="item in unitType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="单价" prop="unitPrice">
                  <el-input v-model="editForm.unitPrice" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="数量" prop="number">
                  <el-input v-model="editForm.number" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="生产日期" prop="registrar">
                   <el-date-picker
                      v-model="editForm.productionDate"
                      @change="doFilter"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                   ></el-date-picker>
                </el-form-item>
                <el-form-item label="材料图片:">
                  <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl1"
                    :headers="uploadHead1"
                    :data="{type:229}"
                    :show-file-list="false"
                    :on-success="handleIconSuccess"
                  >
                    <img v-if="icon" :src="icon" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
                 <el-form-item label="发票图片:">
                  <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl1"
                    :headers="uploadHead1"
                    :data="{type:229}"
                    :show-file-list="false"
                    :on-success="handleIconSuccess1"
                  >
                    <img v-if="invoice" :src="invoice" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="editFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddRow('editForm')">确 定</el-button>
              </div>
            </el-dialog>
            <!-- 导入弹出框 -->
            <el-dialog
              :title="dialogTitle1"
              :visible.sync="imoportVisible"
              center
              :append-to-body="true"
              :before-close="handleClose1"
              :lock-scroll="false"
              width="30%"
            >
              <template>
                <el-table :data="tableData1" style="width: 100%" border>
                  <el-table-column label="状态">
                    <template slot-scope="scope">
                      <span v-if="scope.row.code==200">
                        <i class="el-icon-circle-check" style="color:#07C160"></i>
                      </span>
                      <span v-if="scope.row.code==500">
                        <i class="el-icon-warning-outline" style="color:#f00"></i>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="reason" label="原因">
                    <template slot-scope="scope">
                      <span v-if="scope.row.code==200" style="color:#07C160">{{scope.row.data}}</span>
                      <span v-if="scope.row.code==500" style="color:#f00">{{scope.row.data}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-dialog>
            <!-- 二维码弹出框 -->
            <el-dialog
              :title="codeTit"
              :visible.sync="codeVis"
              center
              :append-to-body="true"
              :lock-scroll="false"
              width="30%"
              style="height:100%;"
            >
              <div class="erCode">
                <vue-qr :text="codeUrl" :size="200"></vue-qr>
                <!-- <p style="width:100%;text-align:center;">
                        <el-button type="primary" @click="downCode">确 定</el-button>
                </p>-->
              </div>
            </el-dialog>
            <!-- 修改发票 -->
              <el-dialog
              :title="diaTitle"
              :visible.sync="editFormVisible1"
              center
              :append-to-body="true"
              :lock-scroll="false"
              width="30%"
            >
              <el-form
                :model="editForm"
                ref="editForm"
                label-width="35%"
                label-position="left"
                class="teamPage"
                :rules="teamRules"
              >
                 <el-form-item label="发票图片:">
                  <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl1"
                    :headers="uploadHead1"
                    :data="{type:229}"
                    :show-file-list="false"
                    :on-success="handleIconSuccess1"
                  >
                    <img v-if="invoice" :src="invoice" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="editFormVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddRow('editForm')">确 定</el-button>
              </div>
            </el-dialog>
            <!-- 修改备注 -->
              <el-dialog
              :title="remarksTitle"
              :visible.sync="remarkVis"
              center
              :append-to-body="true"
              :lock-scroll="false"
              width="30%"
            >
              <el-form
                :model="remarkForm"
                ref="editForm"
                label-width="20%"
                label-position="right"
                class="teamPage"
              >
                <el-form-item label="备注:">
                  <el-input type="textarea" v-model="remarkForm.remarks"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="remarkVis = false">取 消</el-button>
                <el-button type="primary" @click="remarkRow()">确 定</el-button>
              </div>
            </el-dialog>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../../untils/port.js'
import util from '../../../untils/util.js'
import base from '../../../untils/base'
import vueQr from 'vue-qr'
export default {
  components: {
    vueQr,
  },
  data() {
    var checkPrice = (rule, value, callback) => {
      // let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
      if (value == '') {
        callback(new Error('请输入单价'))
      } else if (!this.isCellPrice(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error('请输入正确的格式!'))
      } else {
        callback()
      }
    }
    return {
      dataTree: [
        { name: '原材料', itemsType: '1' },
        { name: '半成品', itemsType: '2' },
        { name: '成品', itemsType: '3' },
        { name: '预构件', itemsType: '4' },
      ],
      listData: [],
      search: {
        //查询
        name: '',
        groupId: '',
        date: '',
        type: '1',
        itemsType: '1',
        userType: util.session.get('roleId'),
        supplier:''
      },
      classId: '', //班组id
      // currentPage: 1,
      // pageSize: 10,
      // totalItems: 0,
      dataText: '数据加载中...',
      uploadUrl: base.url + '/inoutApply/uploadInoutApply',
      uploadHead: {
        accessToken: this.$store.state.token,
      },
      uploadData: {
        personId: '',
        type: '1',
        itemsType: '1',
        userType: util.session.get('roleId'),
        groupId: '',
      },
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      currentNodekey: '', //默认选中的节点树
      expandedkeys: [], //默认展开的节点树
      dialogTitle1: '导入结果',
      imoportVisible: false,
      tableData1: [],
      editFormVisible: false,
      diaTitle: '',
      editForm: {
        id:"",
        personId: '', //添加人
        type: '1',
        itemsType: '1',
        userType: util.session.get('roleId'),
        supplier: '', //供应商
        materialName: '', // 材料名称
        specifications: '', //规格公司
        measuringUnit: '', //计量单位
        unitPrice: '', //单价
        number: '',
        summation: '',
        registrar: '',
        materialCoding: '',
        materialPhoto: '',
        productionDate:'',
      },
      unitType: [],
      teamRules: {
        materialCoding: [
          {
            required: true,
            message: '请输入产品编号,无产品编号,可选生成编号',
            trigger: 'blur',
          },
        ],
        supplier: [
          { required: true, message: '请输入供应商', trigger: 'blur' },
        ],
        materialName: [
          { required: true, message: '请输入材料名称', trigger: 'blur' },
        ],
        specifications: [
          { required: true, message: '规格型号', trigger: 'blur' },
        ],
        measuringUnit: [
          { required: true, message: '请选择计量单位', trigger: 'blur' },
        ],
        // unitPrice: [{ required: true, validator: checkPrice, trigger: 'blur' }], //validator: checkphone是验证手机的引入checkphone函数
        // number: [{ required: true, validator: checkPrice, trigger: 'blur' }],
      },
      //二维码
      codeVis: false,
      codeUrl: '',
      codeTit: '',
      uploadUrl1: base.url + '/upload/uploadPhoto', //上传地址
      uploadHead1: {
        accessToken: util.session.get('token'),
      },
      icon: '',//材料图片
      invoice:'',//发票图片
      http:base.httpCtx,
      nameCode:'产品编码',
      nameMat:'材料名称',
      editFormVisible1:false,
      //备注
      remarkVis:false,
      remarkForm:{
        id:'',
        remarks:''
      },
      remarksTitle:'',//
    }
  },
  created() {
    // if (util.session.get('roleId') == '4') {
      this.search.groupId = util.session.get('groupId')
    // } else {
    //   this.search.groupId = util.session.get('proId')
    // }
  },
  mounted() {
    this.uploadData.personId = this.$store.state.user.id
    this.uploadData.groupId = this.search.groupId

    if (this.dataTree.length > 0) {
      this.currentNodekey = this.dataTree[0].itemsType
      this.expandedkeys.push(this.dataTree[0].itemsType)
      this.$nextTick(() => {
        // treeBox 元素的ref   value 绑定的node-key
        this.$refs.tree.setCurrentKey(this.currentNodekey)
      })
    }
    this.getData()
    this.getMate()
  },
  methods: {
    // 搜索数据
    doFilter(index) {
      // this.search.startDate = this.date ? this.date[0] : ''
      // this.search.endDate = this.date ? this.date[1] : ''
      this.search.personStatus = index
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      myHttp.selectInoutApply(this.search).then(
        function (resp) {
          if (resp.data.code == '200') {
            that.listData = resp.data.data.InoutApply || []
            for (var i = 0; i < that.listData.length; i++) {
              that.listData[i].registrar = that.$store.state.user.name
              that.listData[i].materialPhoto = that.listData[i].materialPhoto && that.listData[i].materialPhoto!=''?that.listData[i].materialPhoto:''
              that.listData[i].invoicePhoto = that.listData[i].invoicePhoto && that.listData[i].invoicePhoto!=''?that.listData[i].invoicePhoto:''
              that.listData[i].srcList = that.listData[i].materialPhoto && that.listData[i].materialPhoto!=''?[base.httpCtx+that.listData[i].materialPhoto]:[]
              that.listData[i].srcList1 = that.listData[i].invoicePhoto && that.listData[i].invoicePhoto!=''?[base.httpCtx+that.listData[i].invoicePhoto]:[]
            }
            if ((resp.data.data.InoutApply, length == 0)) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function () {
          that.dataText = '服务器繁忙中，请稍后请求'
        }
      )
    },
    // 查询所有的材料编码
    getMate() {
      var that = this
      myHttp
        .selectApplyCodingList({
          materialCoding: this.editForm.materialCoding,
          measuringUnit: this.editForm.measuringUnit,
          specifications: this.editForm.specifications,
          supplier: this.editForm.supplier,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list =
              resp.data.data.ApplyCoding && resp.data.data.ApplyCoding[0]
            console.log(list)
            if (list) {
              that.editForm.materialCoding = list.materialCoding
              that.editForm.materialName = list.materialName
              that.editForm.measuringUnit = list.measuringUnit
              that.editForm.specifications = list.specifications
              that.editForm.supplier = list.supplier
              that.editForm.measuringUnit = list.measuringUnit
            }
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    //获取字典表
    zidian() {
      var that = this
      myHttp
        .getDictByType({
          type: 'user_type',
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.dictList || []
          }
        })
    },
    // weight_type
    // 获取计量单位
    getUnit() {
      var that = this
      myHttp
        .getDictByType({
          type: 'weight_type',
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.dictList || []
            that.unitType = list
          }
        })
    },
    //
    // handleSizeChange(val) {
    //   this.pageSize = val
    //   this.handleCurrentChange(this.currentPage)
    // },
    // handleCurrentChange(val) {
    //   this.currentPage = val
    //   this.currentChangePage()
    // },
    // 监控当前页码
    // currentChangePage(list) {
    //   this.getData()
    // }

    //点击树形结构
    handleNodeClick(data) {
      console.log(data)
      this.search.itemsType = data.itemsType
      this.editForm.itemsType = data.itemsType
      this.nameCode=this.editForm.itemsType!='4'?'产品编码':'构件编码'
      this.nameMat = this.editForm.itemsType!='4'?'材料名称':'构件名称'
      this.getData()
      console.log(this.editForm.itemsType)
    },

    watchInput(e) {
      // console.log(e)
      this.search.personStatus = e
      this.getData()
    },
    /**添加材料 */
    add() {
      this.diaTitle = '添加材料'
      this.getUnit()
      this.editForm = {
        personId: '', //添加人
        type: '1',
        date: '',
        itemsType: '1',
        userType: util.session.get('roleId'),
        supplier: '', //供应商
        materialName: '', // 材料名称
        specifications: '', //规格公司
        measuringUnit: '', //计量单位
        unitPrice: '', //单价
        number: '',
        summation: '',
        registrar: '',
        groupId: '',
        date: '',
        materialCoding: '',
        materialPhoto:'',
        invoicePhoto:'',
        productionDate:'',//生产日期
      }
      this.icon='',
      this.invoice=''
      this.editFormVisible = true
    },
   // 修改发票信息
   edit(index,row){
   this.diaTitle = '修改发票'
   this.editForm.id=row.id
  //  this.editForm.
   this.editFormVisible1=true
    this.invoice =row.invoicePhoto && row.invoicePhoto != '' ? base.httpCtx + row.invoicePhoto: ''
   },

    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editForm.personId = this.$store.state.user.id
          this.editForm.groupId = this.search.groupId
          this.editForm.itemsType = this.search.itemsType
          this.editForm.registrar = this.$store.state.user.name
          this.editForm.summation = parseInt(
            this.editForm.unitPrice * this.editForm.number
          )
          console.log(this.editForm.id)
          if(this.editForm.id==''||''==this.editForm.id||!this.editForm.id){
           myHttp.addInoutApply(this.editForm).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('添加成功')
              that.editFormVisible = false
              that.currentPage = 1
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
          }else{
            myHttp.addInvoicePhoto({
              id:this.editForm.id,
              invoicePhoto:that.editForm.invoicePhoto
            }).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('添加发票成功')
              that.editFormVisible1 = false
              that.currentPage = 1
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
          }

        } else {
          return false
        }
      })
    },

    /**
     * 导出合同
     */
    exportma(flag) {
      var token = util.session.get('token')
      window.open(
        myHttp.exportInoutApply +
          '?type=' +
          this.search.type +
          '&itemsType=' +
          this.search.itemsType +
          '&groupId=' +
          this.search.groupId +
          '&userType=' +
          this.search.userType +
          '&date=' +
          this.search.date +
          '&name=' +
          this.search.name +
          '&supplier=' +
          this.search.supplier +
          '&flag=' +
          flag +
          '&accessToken=' +
          token
      )
    },
    /**
     * 导入表监听方法
     */
    handleAppSuccess(res, file) {
      console.log(res)
      if (res.code == '200') {
        // this.$message.success('上传成功')
        console.log(res)
        this.imoportVisible = true
        this.tableData1 = res.data.list
        this.getData()
      } else {
        this.$message.error(res.msg)
      }
    },
    //上传合同成功监听方法
    // handleAppSuccess(res, file, opt, id) {
    //   console.log(res, file, opt, id)
    //   if (res.code == '200') {
    //     //this.$message.success('上传成功')
    //     var path = res.data.saveUrls
    //     this.saveImg(id, path)
    //     //console.log(res)
    //     //this.getData()
    //   } else {
    //     this.$message.error(res.msg)
    //   }
    // },

    //保存合同图片信息
    // saveImg(id, path) {
    //   var that = this
    //   myHttp
    //     .saveContractImg({
    //       id: id,
    //       path: path
    //     })
    //     .then(function(resp) {
    //       console.log(resp)
    //       if (resp.data.code == '200') {
    //         that.$message.success('上传成功')
    //         that.getData()
    //       } else {
    //         that.$message.error(resp.msg)
    //       }
    //     })
    // },
    auto() {
      console.log(111)
      // var date = new Date();
      // var year = date.getFullYear().toString();
      // var month = (date.getMonth()+1).toString();
      // var day = date.getDate().toString();
      // var hour = date.getHours().toString();
      // var minute = date.getMinutes().toString();
      // var second = date.getSeconds().toString();
      // var time = year+month+day+hour+minute+second
      var str = this.randomString(8)
      this.editForm.materialCoding = 'TS' + str
    },
    randomString(len, charSet) {
      charSet = charSet || '0123456789'
      var randomString = ''
      for (var i = 0; i < len; i++) {
        var randomPoz = Math.floor(Math.random() * charSet.length)
        randomString += charSet.substring(randomPoz, randomPoz + 1)
      }
      return randomString
    },
    handleClose1() {
      this.imoportVisible = false
    },
    // 验证数字正则
    isCellPrice(val) {
      if (!/^[0-9]+.?[0-9]*$/.test(val)) {
        return false
      } else {
        return true
      }
    },
    //展示二维码
    erCode(index, row) {
      this.codeVis = true
      this.codeUrl = '/pages/prefabrica/prefabrica?id=' + row.id
      this.codeTit = row.materialCoding
    },
    handleIconSuccess(res, file) {
      this.icon = URL.createObjectURL(file.raw)
      // console.log(res.data)

      this.editForm.materialPhoto = res.data.saveUrls
    },
      handleIconSuccess1(res, file) {
      this.invoice = URL.createObjectURL(file.raw)
      // console.log(res.data)

      this.editForm.invoicePhoto = res.data.saveUrls
    },

    /**
     * 添加备注
     */
    remarkRow(){
      this.remarkVis = false
      var that = this
      myHttp.putInoutApplyNoteById({
        id:this.remarkForm.id,
        note:this.remarkForm.remarks
      }).then(function(resp){
        if(resp.data.code=='200'){
          that.$message.success('添加备注成功')
          that.getData()
        }else{
          this.$message.error(res.msg)
        }
      })
    },
    //展示备注弹出框
    addMarks(row){
      this.remarkForm.id = row.id
      this.remarkForm.remarks = row.note
      this.remarksTitle = row.name
      this.remarkVis = true
    },

  },
}
</script>
<style>
/**
*图片放大右上角关闭按钮
*/
.el-image-viewer__close i {
  font-size: 4vh;
  color: #fff;
}
/* @import '../../assets/css/common.css'; */
</style>
<style scoped>
/* .content {
  height: 100%;
  width: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 1%;
} */
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
}
.grid-search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 40%;
}
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.build-table {
  height: calc(100% - 80px);
}
.active {
  background: #409eff;
  color: #fff;
}
.contract-con {
  width: 100%;
  background: #fff;
  height: 125px;
  font-size: 14px;
}
.contract-con p {
  width: 100%;
  padding: 2px 20px;
  text-align: left;
}
.content
  >>> .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  color: #4d95fd;
  font-weight: bold;
  padding: 10px 0px;
}
/* .el-dialog__body>>>.el-form-item>.el-form-item__content>.el-input-group--append .el-input__inner{
  width: 200px !important;
} */
.content >>> .el-tree {
  padding: 30px;
}
.content >>> .el-input > .el-input__inner {
  width: 188px;
}
.erCode {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.avatar {
  width: 100%;
}
</style>
